import React from 'react';
import { connect } from 'react-redux';
import Style from './DataControlEntity.module.css';

// Read-only registry of service entities and their owned attributes (the former
// separate Entity layer has been collapsed into the service entity). Seeded by
// DB scripts; not editable in the portal.
const ServiceEntities = (props) => {
  const { serviceEntities } = props;

  return (
    <div>
      <div style={{ marginBottom: '8px' }}>
        <h1 className={Style.pageTitle}>Service Entities</h1>
        <p className={Style.pageSubtitle}>Named, reusable element templates and the attributes they expose to scan
          rules. This catalog is read-only and maintained by the platform.</p>
      </div>

      <div className={Style.card}>
        <div className={Style.cardHeader}><div className={Style.cardTitle}>Service Entity Registry</div></div>
        <div className={Style.cardBody}>
          <table className={Style.table}>
            <thead><tr><th>Service Entity</th><th>Kind</th><th>Attributes</th><th>Order</th><th>Status</th></tr></thead>
            <tbody>
              {(serviceEntities || []).map((se) => (
                <tr key={se.serviceEntityId}>
                  <td><div className={Style.rowTitle}>{se.name}</div><div className={Style.mono}>{se.code}</div></td>
                  <td><span className={`${Style.badge} ${Style.neutral}`}>{se.kind}</span></td>
                  <td>{(se.attributes || []).map((a) => (
                    <span key={a.attributeId} className={Style.chipAttr}>{a.name} <span className={Style.mono}>({a.dataType})</span></span>
                  ))}</td>
                  <td>{se.iOrder}</td>
                  <td><span className={`${Style.badge} ${se.isActive ? Style.low : Style.neutral}`}>{se.isActive ? 'Active' : 'Inactive'}</span></td>
                </tr>
              ))}
              {(!serviceEntities || serviceEntities.length === 0) && (
                <tr><td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>No service entities</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceEntities: state.entities.dataControlEntity.serviceEntities,
});

export default connect(mapStateToProps)(ServiceEntities);
